module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit_wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tip_word"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_vm._v("友情提示：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {
    staticClass: "grid-content f12 f666 lh20"
  }, [_vm._v("1.请按照大V服务平台信息要求填写正确的供应商信息。")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content f12 f666 lh20"
  }, [_vm._v("2.所有资质信息格式要求：复印件加盖公司红章之后，再扫描上传到大V服务平台。请确保证件内容清晰可见，扫描件大小不得超过1M。")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content f12 f666 lh20"
  }, [_vm._v("3.提交审核之后，大V店工作人员会在3个工作日内进行审核。")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content f12 f666 lh20"
  }, [_vm._v("4.入驻过程有任何疑问，请按照如下方式解决："), _c('br'), _vm._v("（1）如果有对接的采销，请直接联系采销处理解决；"), _c('br'), _vm._v("（2）如果还未对接采销，直接发送问题至邮箱：bd@davdian.com 。")])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [_c('div', {
    staticClass: "grid-content f12 f666 lh20"
  }, [_vm._v("5."), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "/suppliers/index2/#/intro"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#58b7ff"
    }
  }, [_vm._v("点击此处")])]), _vm._v("查看供应商入驻介绍。")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pl10 mt20"
  }, [_c('span', {
    staticClass: "dib"
  }, [_vm._v("税务信息")]), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt20"
  }, [_c('el-form', {
    ref: "finalForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.finalForm,
      "rules": _vm.rules,
      "label-width": "207px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "纳税人识别号：",
      "prop": "taxpayerRegistrationCode"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入纳税人识别号"
    },
    model: {
      value: (_vm.finalForm.taxpayerRegistrationCode),
      callback: function($$v) {
        _vm.$set(_vm.finalForm, "taxpayerRegistrationCode", $$v)
      },
      expression: "finalForm.taxpayerRegistrationCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "纳税人类型："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star105"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-radio-group', {
    staticClass: "ml_10",
    attrs: {
      "disabled": _vm.applyStatus == 9
    },
    on: {
      "change": _vm.typeChange
    },
    model: {
      value: (_vm.finalForm.taxpayerType),
      callback: function($$v) {
        _vm.$set(_vm.finalForm, "taxpayerType", $$v)
      },
      expression: "finalForm.taxpayerType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_c('span', {
    staticClass: "f14 f666"
  }, [_vm._v("一般纳税人")])]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_c('span', {
    staticClass: "f14 f666"
  }, [_vm._v("小规模纳税人")])])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isList),
      expression: "isList"
    }],
    staticClass: "mt20",
    attrs: {
      "label": "一般纳税人资格认定表："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star178"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "f666 f12 ml_10"
  }, [_vm._v("复印件需加盖公司红章扫描上传")]), _vm._v(" "), _c('el-upload', {
    attrs: {
      "action": "/suppliers/uploadImages?biz=0",
      "file-list": _vm.finalForm.file,
      "list-type": "picture-card",
      "name": "pic",
      "before-upload": _vm.beforeUpload,
      "on-preview": _vm.handlePictureCardPreview,
      "on-success": _vm.handleUpload,
      "on-remove": _vm.handleRemoveGeneralTaxpayerFile
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M，可上传多张")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pic_1),
      expression: "pic_1"
    }],
    staticClass: "pic_tip"
  }, [_vm._v("请上传图片")])], 1), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("货款支付账户")]), _c('span', {
    staticClass: "second_line"
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "银行开户名：",
      "prop": "accountName"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入银行开户名"
    },
    model: {
      value: (_vm.finalForm.accountName),
      callback: function($$v) {
        _vm.$set(_vm.finalForm, "accountName", $$v)
      },
      expression: "finalForm.accountName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "银行帐号：",
      "prop": "accountNumber"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入银行帐号"
    },
    model: {
      value: (_vm.finalForm.accountNumber),
      callback: function($$v) {
        _vm.$set(_vm.finalForm, "accountNumber", $$v)
      },
      expression: "finalForm.accountNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户银行：",
      "prop": "bankName"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入开户银行"
    },
    model: {
      value: (_vm.finalForm.bankName),
      callback: function($$v) {
        _vm.$set(_vm.finalForm, "bankName", $$v)
      },
      expression: "finalForm.bankName"
    }
  })], 1), _vm._v(" "), (_vm.finalForm.registeredCountry != 1) ? _c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "SwiftCode："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star100"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-input', {
    staticClass: "w500 ml_10",
    attrs: {
      "placeholder": "请输入SwiftCode",
      "maxlength": 35
    },
    model: {
      value: (_vm.finalForm.swiftCode),
      callback: function($$v) {
        _vm.$set(_vm.finalForm, "swiftCode", $$v)
      },
      expression: "finalForm.swiftCode"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.finalForm.registeredCountry == 1) ? _c('el-form-item', {
    attrs: {
      "label": "省："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star50"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入省"
    },
    model: {
      value: (_vm.finalForm.province),
      callback: function($$v) {
        _vm.$set(_vm.finalForm, "province", $$v)
      },
      expression: "finalForm.province"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.finalForm.registeredCountry == 1) ? _c('el-form-item', {
    attrs: {
      "label": "市："
    }
  }, [_c('span', {
    staticClass: "main_word rule_star50"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入市"
    },
    model: {
      value: (_vm.finalForm.city),
      callback: function($$v) {
        _vm.$set(_vm.finalForm, "city", $$v)
      },
      expression: "finalForm.city"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt50 mb50",
    attrs: {
      "label-width": "207px"
    }
  }, [_c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goBrand
    }
  }, [_vm._v("上一页")]), _vm._v(" "), (_vm.applyStatus == 0 || _vm.applyStatus == 1) ? _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveForm
    }
  }, [_vm._v("保存草稿")]) : _vm._e(), _vm._v(" "), (_vm.applyStatus == 0 || _vm.applyStatus == 1) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('finalForm')
      }
    }
  }, [_vm._v("提交审核")]) : _vm._e(), _vm._v(" "), (_vm.applyStatus == 3 || _vm.applyStatus == 9) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitForm('finalForm')
      }
    }
  }, [_vm._v("重新提交审核")]) : _vm._e()], 1)], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit_top"
  }, [_c('div', {
    staticClass: "edit_tab"
  }, [_vm._v("供应商信息")]), _c('div', {
    staticClass: "edit_tab"
  }, [_vm._v("品牌信息")]), _c('div', {
    staticClass: "edit_tab active_tab"
  }, [_vm._v("财务信息")]), _c('div', {
    staticClass: "edit_tab"
  }, [_vm._v("合同协议")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53b9a322"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/edit/financeInfo.vue
// module id = 528
// module chunks = 0